/*
 * @Author: HWD
 * @Date: 2021-10-27 16:00:24
 * @LastEditors: HWD
 * @LastEditTime: 2021-10-27 16:20:05
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import router from './router'

Vue.config.productionTip = false
Vue.use(ElementUI)
// new Vue({
//   render: h => h(App),
// }).$mount('#app')

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')